import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoAcao from "./DocumentoAcao";

export default class DocumentoAcessoUsuario {
    usuario: Usuario; 
    acoes: DocumentoAcao[];

    constructor(usuario: Usuario, acoes: DocumentoAcao[]) {
        this.usuario = usuario;
        this.acoes = acoes;
    }
}